export enum UserRole {
  SALES,
  MERCHANT_SUPPORT,
  LEGAL,
  RM,
  SUPER_ADMIN,
  UNKNOWN,
}
